import { Component, OnInit } from "@angular/core";
import { AppCore } from "src/app/utils/classes/app-core";

@Component({
  selector: "app-agent-map",
  templateUrl: "./agent-map.component.html",
  styleUrls: ["./agent-map.component.scss"],
})
export class AgentMapComponent extends AppCore implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {}
}
